import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center gap-8 w-full animate-slideFadeIn" }
const _hoisted_2 = { class: "flex flex-col gap-3 w-full max-w-md pt-2 px-4" }
const _hoisted_3 = { class: "text-center font-normal text-sm text-gray-400 pt-3" }

import { useRouter } from "vue-router"

export default /*@__PURE__*/_defineComponent({
  __name: 'ChoosePathForm',
  emits: ["pathSelected", "switchMode"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const router = useRouter()

function selectPath(path: 'creator' | 'brand') {
    if (path === 'brand') {
        window.location.href = 'https://tawa.digital/contact-us/'
    } else {
        router.push(`/auth/signup/${path}`)
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex flex-col items-center justify-center gap-2 w-full" }, [
      _createElementVNode("h2", { class: "text-3xl font-semibold text-gray-600 tracking-normal text-center" }, "Welcome to TAWA"),
      _createElementVNode("p", { class: "text-sm font-medium text-gray-500 text-center" }, "Choose your path to get started")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (selectPath('creator'))),
        class: "w-full py-3 rounded-2xl text-gray-500 font-medium border border-gray-300 hover:bg-purple-50 transition"
      }, " Continue as a Creator "),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (selectPath('brand'))),
        class: "w-full py-3 rounded-2xl text-gray-500 font-medium border border-purple-300 hover:bg-purple-50 transition"
      }, " Continue as a Brand ")
    ]),
    _createElementVNode("p", _hoisted_3, [
      _cache[3] || (_cache[3] = _createTextVNode(" Already have an account? ", -1)),
      _createElementVNode("button", {
        class: "text-purple-500 font-semibold hover:underline ml-1",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/auth/signin')))
      }, " Sign in ")
    ])
  ]))
}
}

})